import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSpaceModule } from 'ng-zorro-antd/space';

@NgModule({
  declarations: [],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzAvatarModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzSpinModule,
    NzNotificationModule,
    NzMessageModule,
    NzDropDownModule,
    NzToolTipModule,
    NzSelectModule,
    NzDatePickerModule,
    NzTimePickerModule,
    NzTableModule,
    NzDrawerModule,
    PdfViewerModule,
    NzImageModule,
    NzModalModule,
    NzPopconfirmModule,
    NzDividerModule,
    NzInputNumberModule,
    NzEmptyModule,
    NzTreeModule,
    NzBreadCrumbModule,
    NzTreeSelectModule,
    NzSwitchModule,
    NzCheckboxModule,
    NzRadioModule,
    NzPaginationModule,
    NzUploadModule,
    NzAlertModule,
    NzTagModule,
    NzCardModule,
    NzBadgeModule,
    NzCommentModule,
    NzDescriptionsModule,
    NzListModule,
    NzResultModule,
    NzProgressModule,
    NzTabsModule,
    NzPopoverModule,
    NzCollapseModule,
    NzStepsModule,
    NzSpaceModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzAvatarModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzSpinModule,
    NzNotificationModule,
    NzMessageModule,
    NzDropDownModule,
    NzToolTipModule,
    NzSelectModule,
    NzDatePickerModule,
    NzTimePickerModule,
    NzTableModule,
    NzDrawerModule,
    PdfViewerModule,
    NzImageModule,
    NzModalModule,
    NzPopconfirmModule,
    NzDividerModule,
    NzInputNumberModule,
    NzEmptyModule,
    NzTreeModule,
    NzBreadCrumbModule,
    NzTreeSelectModule,
    NzSwitchModule,
    NzCheckboxModule,
    NzRadioModule,
    NzPaginationModule,
    NzUploadModule,
    NzAlertModule,
    NzTagModule,
    NzCardModule,
    NzBadgeModule,
    NzCommentModule,
    NzDescriptionsModule,
    NzListModule,
    NzResultModule,
    NzProgressModule,
    NzTabsModule,
    NzPopoverModule,
    NzCollapseModule,
    NzStepsModule,
    NzSpaceModule
  ],
  providers: [DatePipe],
})
export class ImportsModule {}
